import React from 'react';

const SetupSummary = () => {
  return (
    <div>
      <h2 className={'title-m m-b-12'}>Alert status summary</h2>
      <div className={'text-m'}>
        Please review the setup options for this alert status on the right. If everything appears to be correct, simply
        click “Save status”.
      </div>
    </div>
  );
};

export default SetupSummary;
